// extracted by mini-css-extract-plugin
export default {"hollowButton":"_3T1kRSFs"};